export const ANALYZING_REFETCH_INTERVAL_MS = 5000;

/** Widening bands, keyed on how long *anything* has been analyzing.
 *
 * A single certificate normally resolves inside the first band, so the common
 * case is unchanged. A 50-file batch drops to a slower cadence rather than
 * hammering the list endpoint every 5 s for minutes, and a document stuck in
 * ANALYZING (a poison-queued job, say) stops polling instead of spinning
 * forever, which is what happens today. */
const ANALYZING_REFETCH_BANDS = [
  { untilMs: 60_000, intervalMs: ANALYZING_REFETCH_INTERVAL_MS },
  { untilMs: 5 * 60_000, intervalMs: 15_000 },
  { untilMs: 15 * 60_000, intervalMs: 30_000 },
] as const;

/** `analyzingSinceMs` is when the current analyzing streak started, or null
 * when nothing is analyzing. Returns false to stop polling. */
export const resolveAnalyzingRefetchInterval = (
  analyzingSinceMs: number | null,
  nowMs: number,
): number | false => {
  if (analyzingSinceMs === null) {
    return false;
  }

  const elapsedMs = Math.max(nowMs - analyzingSinceMs, 0);

  for (const band of ANALYZING_REFETCH_BANDS) {
    if (elapsedMs < band.untilMs) {
      return band.intervalMs;
    }
  }

  return false;
};
